"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BusySpinner;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _hexRgb = _interopRequireDefault(require("hex-rgb"));
function BusySpinner(_ref) {
  var withSkrim = _ref.withSkrim,
    noBackground = _ref.noBackground;
  var theme = (0, _material.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      position: 'fixed',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      backgroundColor: withSkrim ? "".concat((0, _hexRgb.default)("".concat(theme.palette.TwClrBaseGray025), {
        alpha: 0.6,
        format: 'css'
      })) : 'none',
      zIndex: 2000,
      backgroundImage: noBackground ? 'none' : 'linear-gradient(180deg,' + "".concat((0, _hexRgb.default)("".concat(theme.palette.TwClrBaseGreen050), {
        alpha: 0,
        format: 'css'
      }), " 0%,") + "".concat((0, _hexRgb.default)("".concat(theme.palette.TwClrBaseGreen050), {
        alpha: 0.24,
        format: 'css'
      }), " 100%)")
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(5),
    flexDirection: "column",
    height: "100%"
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, null)));
}